export default (state = [], action) => {
    
    switch (action.type){
        case 'MATRIX':
            return action.payload;
        default:
            return state;
    }
};